import { Grid, IconButton, Stack, Typography, useMediaQuery, useTheme } from "@mui/material";
import React, { useMemo } from "react";
import FiltersIcon from "src/icons/transactions/FiltersIcon";
import SummaryIcon from "src/icons/transactions/SummaryIcon";
import {
  GetUserCurrencyTransactionsApiArg,
  useGetUserDatav2Query,
} from "src/store/features/api/generated";
import { initialFilterData } from "../reports/utils/ReportTools";
import TransactionReports from "./TransactionReports";
import FilterMobile from "./FilterMobile";
import { FilterData, RawTransactions } from "./types";
import EofyStatementButton from "./EofyStatementButton";
import usePermission from "src/utils/hooks/usePermission";

interface MobileFilterProps {
  transactions: RawTransactions;
  currentParams: GetUserCurrencyTransactionsApiArg;
  setParams: (newParams: GetUserCurrencyTransactionsApiArg) => void;
  refetch: () => void;
  lowHigh: string[];
}

const MobileFilter = (props: MobileFilterProps) => {
  const { transactions, currentParams, setParams, refetch, lowHigh } = props;
  const theme = useTheme();
  const [state, toggleExportModal] = React.useReducer((state) => !state, false);
  const [reportsFilter, setReportsFilter] = React.useState<FilterData>(initialFilterData);
  const [openFilter, setOpenFilter] = React.useState<boolean>(false);
  const [isAU, setIsAu] = React.useState<boolean>(false);
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { data: userData } = useGetUserDatav2Query();
  const { isDev } = usePermission();
  const primary = theme.palette.primary.main;
  const secondary = theme.palette.secondary.main;

  const handleSummaryClick = () => {
    toggleExportModal();
  };
  const handleFilterClick = () => {
    setOpenFilter((prev) => !prev);
  };

  useMemo(() => {
    const isAU = userData?.address.country === "AU";
    setIsAu(isAU);
  }, [userData]);
  return (
    <Stack direction="row" justifyContent="flex-end">
      <Grid item container alignItems="center" sx={{ width: "fit-content" }}>
        {isAU && isDev && <EofyStatementButton />}
      </Grid>

      <Grid
        item
        container
        alignItems="center"
        onClick={handleSummaryClick}
        sx={{ width: "fit-content", paddingRight: "16px" }}>
        {!isMobile && (
          <Typography sx={{ paddingRight: "8px", fontWeight: 600 }}>Summary</Typography>
        )}
        <IconButton sx={{ backgroundColor: secondary }}>
          <SummaryIcon />
        </IconButton>
      </Grid>

      <Grid
        id="mobile-filter-button-icon"
        item
        container
        alignItems="center"
        onClick={handleFilterClick}
        sx={{ width: "fit-content" }}>
        {!isMobile && <Typography sx={{ paddingRight: "8px", fontWeight: 600 }}>Filter</Typography>}
        <IconButton sx={{ backgroundColor: primary }}>
          <FiltersIcon color="#FFF" />
        </IconButton>
      </Grid>

      <FilterMobile
        toggleFilter={handleFilterClick}
        showFilter={openFilter}
        transactions={transactions}
        currentParams={currentParams}
        setParams={setParams}
        refetch={refetch}
        lowHigh={lowHigh}
      />

      <TransactionReports
        state={state}
        toggleExportModal={toggleExportModal}
        reportsFilter={reportsFilter}
        setReportsFilter={setReportsFilter}
      />
    </Stack>
  );
};

export default MobileFilter;
